import {React} from "react";
import   "../pages/styles.css";
import  martins from "../images/LeadUs/martin1.png";
import  dupre from "../images/LeadUs/dupre.png";
import  dicks from "../images/LeadUs/dick.png";
import  gonzales from "../images/LeadUs/gonzales.png";
import  henrie from "../images/LeadUs/henrie.png";
import  horne from "../images/LeadUs/horne.png";
import  kroney from "../images/LeadUs/kroney.png";
import  long from "../images/LeadUs/long.png";
import  loewen from "../images/LeadUs/loewen.png";
import  mcgyver from "../images/LeadUs/mcgyver.png";
import  neighbors from "../images/LeadUs/neighbors.png";




const LeadersPage = () => {

     return (
      <div style={{background:"#eceff3f6",justifyContent:"center",}}>
        <h1 className={`boldFancyHeadFontCenter`} >
          2025-2026 Kermis Club Executive Board
        </h1>
        <br/>
        <div className={`blackBodyFontCenter`} style={{display:"grid",alignItems:"center",background:'#eceff3f6'}}>
          Running a non-profit club requires dedicated leadership, unending energy and quick thinking.<br></br>
          We would like to you to and acknowledge the efforts of our board to keep the elegance continuing.
        </div>
        <br/>
        <h3 className="boldFancyHeadFontCenter2">
          Our Officers
        </h3>  
        <div className="container" style={{display:"grid",justifyItems:"center",background:'#eceff3f6',whiteSpace:"pre-wrap",padding:"50px"}}>
          <h4 className="boldFancyHeadFontCenter3" >
            Our Presidents
          </h4>
          <div className="blackBodyFontCenter"  >
            Harry Martin and Betty Maines-Martin
          </div>
          <img src={martins} />
        </div>

        <div className="container" style={{display:"grid",justifyItems:"center",background:'#eceff3f6',whiteSpace:"pre-wrap",padding:"50px"}}>
          <h4 className="boldFancyHeadFontCenter3" >
            Our Vice Presidents
          </h4>
          <div className="blackBodyFontCenter"  >
            Joe and Deonne Sullivan
          </div>
          {/* <img src={empty} /> */}
        </div>
      
        <div className="container" style={{display:"grid",justifyItems:"center",background:'#eceff3f6',whiteSpace:"pre-wrap",padding:"50px"}}>
          <h4 className="boldFancyHeadFontCenter3" >
            Our Secretary
          </h4>
          <div className="blackBodyFontCenter"  >
            Linda Henrie
          </div>
          <img src={henrie} />
        </div>

        <div className="container" style={{display:"grid",justifyItems:"center",background:'#eceff3f6',whiteSpace:"pre-wrap",padding:"50px"}}>
          <h4 className="boldFancyHeadFontCenter3" >
            Our Treasurer
          </h4>
          <div className="blackBodyFontCenter"  >
            Donald Loewen
          </div>
          <img src={loewen} />
        </div>

        <div className="container" style={{display:"grid",justifyItems:"center",background:'#eceff3f6',whiteSpace:"pre-wrap",padding:"50px"}}>
        <h4 className="boldFancyHeadFontCenter3" >
            Our Directors
        </h4>
        <div className="blackBodyFontCenter"  >
         Duke and Helen Dupre
        </div>
        <img src={dupre} />
        <div className="blackBodyFontCenter"  >
         Mel McGyver and Linda Samuel
        </div>
        <img src={mcgyver} />
        
      </div>
      <div className="container" style={{display:"grid",justifyItems:"center",background:'#eceff3f6',whiteSpace:"pre-wrap",padding:"50px"}}>
      
        <h4 className="boldFancyHeadFontCenter3" >
            Our Honorary Directors
        </h4>
        <div className="blackBodyFontCenter"  >
         David and Benita Dick
        </div>
        <img src={dicks} />
        
      </div>
      <div></div>
      <div className={`boldFancyHeadFontCenter2`} >
          <h3>Our Committee Chairs</h3>
      </div>

      <div className="container" style={{display:"grid",justifyItems:"center",background:'#eceff3f6',whiteSpace:"pre-wrap",padding:"50px"}}>
      
        <h4 className="boldFancyHeadFontCenter3" >
            Our Band Liason
        </h4>
        <div className="blackBodyFontCenter"  >
         Gail Horne
        </div>
        <img src={horne} />
        
      </div>
      <div className="container" style={{display:"grid",justifyItems:"center",background:'#eceff3f6',whiteSpace:"pre-wrap",padding:"50px"}}>
      
        <h4 className="boldFancyHeadFontCenter3" >
            Invitations
        </h4>
        <div className="blackBodyFontCenter"  >
         Susan Kroney
        </div>
        <img src={kroney} />
        
      </div>
      <div className="container" style={{display:"grid",justifyItems:"center",background:'#eceff3f6',whiteSpace:"pre-wrap",padding:"50px"}}>
      
        <h4 className="boldFancyHeadFontCenter3" >
            Directory and Website
        </h4>
        <div className="blackBodyFontCenter"  >
         Leslie Neighbors and Simona Bare
        </div>
        <img src={neighbors} />
        
      </div>
      <div className="container" style={{display:"grid",justifyItems:"center",background:'#eceff3f6',whiteSpace:"pre-wrap",padding:"50px"}}>
      
        <h4 className="boldFancyHeadFontCenter3" >
            Dance Chair
        </h4>
        <div className="blackBodyFontCenter"  >
         Melissa Long
        </div>
        <img src={long} />
        
      </div>
      <div className="container" style={{display:"grid",justifyItems:"center",background:'#eceff3f6',whiteSpace:"pre-wrap",padding:"50px"}}>
      
        <h4 className="boldFancyHeadFontCenter3" >
            Dance Chairs
        </h4>
        <div className="blackBodyFontCenter"  >
         Pete and Gillian Gonzales
        </div>
        <img src={gonzales} />
        
      </div>
      <div className="container" style={{display:"grid",justifyItems:"center",background:'#eceff3f6',whiteSpace:"pre-wrap",padding:"50px"}}>
      
        <h4 className="boldFancyHeadFontCenter3" >
            Dance Chair
        </h4>
        <div className="blackBodyFontCenter"  >
         Gail Horne
        </div>
        <img src={horne} />
        
      </div>
      
    </div>
  )
};
   
export default LeadersPage;